/*jslint node: true*/
"use strict";

var ko = require("pli/knockout");

require("../ko-visiblenotification");

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// "NotificationMessage" class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//----------------------------------------
function NotificationMessage() {
    /// <summary>
    /// Define viewmodel.
    /// </summary>
    if (!(this instanceof NotificationMessage)) { return new NotificationMessage(); } // if new was not used, force it now

    this.title = ko.observable("");
    this.message = ko.observable("");
    this.isVisible = ko.observable(false);

    this.hide = this.hide.bind(this);
}


//----------------------------------------
NotificationMessage.prototype.show = function showNotification(options) {
    /// <summary>
    /// Show notification error message.
    /// </summary>
    if (!options) { options = {}; }

    this.title(options.title || "");
    this.message(options.message || "");
    this.isVisible(true);
};


//----------------------------------------
NotificationMessage.prototype.hide = function hideNotification() {
    /// <summary>
    /// Hide notification error message.
    /// </summary>
    this.isVisible(false);
};


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Initialization
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//----------------------------------------
module.exports = NotificationMessage;



//////////////////
// WEBPACK FOOTER
// ./app/common-notificationmessage/notificationMessage.js
// module id = 529
// module chunks = 49